import styles from "./EventTableHistory.module.css";
import eventImg from "../../../../assets/eventImg.png";
import { Col, List, Row } from "antd";
import SearchInput from "../../../../components/searchInput/SearchInput";
import SubmitButton from "../../../../components/submitButton/SubmitButton";
import TextComponent from "../../../../components/textComponent/TextComponent";
import { useWatch } from "antd/es/form/Form";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { useNavigate } from "react-router-dom";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import moment from "moment";

// const events = [
//   {
//     title: "Wedding Ceremony",
//     address: "3707 Irving Place, Arnold, MO 63010",
//     time: "5:00 pm",
//     date: "May 12, 2023",
//     guests: "20",
//     totalGuests: "30",
//     clientName: "James",
//   },
//   {
//     title: "Engagement Ceremony",
//     address: "3707 Irving Place, Arnold, MO 63010",
//     time: "8:30 pm",
//     date: "May 10, 2023",
//     guests: "20",
//     totalGuests: "30",
//     clientName: "Mark",
//   },
//   {
//     title: "Wedding Rehearsal",
//     address: "3707 Irving Place, Arnold, MO 63010",
//     date: "May 12, 2023",
//     time: "8:30 PM",
//     guests: "20",
//     totalGuests: "30",
//     clientName: "Steve",
//   },
// ];

const TableHeader = ({ item, role }) => {
  return (
    <Row className={styles.listItemFirst}>
      <Col xs={24} lg={9}>
        <div className={styles.itemGroup1First}>
          <TextComponent text={item.name} textClass={styles.eventTitle} />
        </div>
      </Col>
      <Col xs={24} lg={15}>
        <Row className={styles.itemGroup2First}>
          <Col lg={6} xl={5} className={styles.group2Col}>
            <TextComponent text={item.date} />
          </Col>
          <Col lg={6} xl={5} className={styles.group2Col}>
            <TextComponent text={item.time} />
          </Col>
          {role === roles.client ? (
            <>
              <Col lg={6} xl={5} className={styles.group2Col}>
                <TextComponent text={item.guests} textClass={styles.guests} />
              </Col>
              <Col lg={6} xl={5} className={styles.group2Col}>
                <TextComponent
                  text={item.attending}
                  textClass={styles.guests}
                />
              </Col>
            </>
          ) : (
            <Col lg={6} xl={5} className={styles.group2Col}>
              <TextComponent text={item.clientName} textClass={styles.guests} />
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

const LeftGroup = ({ item }) => {
  return (
    <div className={styles.itemGroup1}>
      <img src={item?.image} className={styles.eventImage}></img>
      <div className={styles.textGroup}>
        <TextComponent text={item.name} textClass={styles.eventTitle} />
        <TextComponent text={item.address} textClass={styles.eventAddr} />
      </div>
    </div>
  );
};

const RightGroup = ({ item, role }) => {
  return (
    <Row gutter={[0, 16]} className={styles.itemGroup2}>
      <Col xs={24} sm={8} lg={6} xl={5} className={styles.group2Col}>
        <TextComponent text="Event Date" textClass={styles.infoTitle} />
        <TextComponent text={moment(item.date).format("MMM DD")} />
      </Col>
      <Col xs={24} sm={8} lg={6} xl={5} className={styles.group2Col}>
        <TextComponent text="Event Time" textClass={styles.infoTitle} />
        <TextComponent
          text={
            moment(item.date).format("ddd") +
            " " +
            moment(item?.start_time).format("hh:mm A")
          }
        />
      </Col>
      {role === roles.client ? (
        <>
          <Col xs={24} sm={8} lg={6} xl={5} className={styles.group2Col}>
            <TextComponent text="Total Guests" textClass={styles.infoTitle} />
            <TextComponent text={item.no_of_guest} textClass={styles.guests} />
          </Col>
          <Col xs={24} sm={8} lg={6} xl={5} className={styles.group2Col}>
            <TextComponent text="Attending" textClass={styles.infoTitle} />
            <TextComponent
              text={item.no_of_attendee}
              textClass={styles.guests}
            />
          </Col>
        </>
      ) : (
        <Col xs={24} sm={8} lg={6} xl={5} className={styles.group2Col}>
          <TextComponent text="Client Name" textClass={styles.infoTitle} />
          <TextComponent text={item.clientName} textClass={styles.guests} />
        </Col>
      )}
    </Row>
  );
};

const EventTableHistory = ({ showCreateBtn }) => {
  const events = useSelector((state) => state.EventReducer.EventHistory);
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  console.log("eventsssss", events);
  const ref = useRef();
  const [search, setSearch] = useState();
  const [loading, setloading] = useState(true);
  const [Hloading, setHloading] = useState(true);
  const { height, width } = useWindowDimensions();
  const navigate = useNavigate();
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");
  const dispatch = useDispatch();
  useEffect(() => {
    let userData = {
      status: "past",
      name: "",
    };
    dispatch(EventMiddleware.getEvents(userData)).then((data) => {});
  }, []);

  const onSearch = (val) => {
    let userData = {
      status: "past",
      name: val,
    };
    setSearch(val);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      setloading(true);
      setHloading(true);
      dispatch(EventMiddleware.getEvents(userData))
        .then((data) => {
          setloading(false);
          setHloading(false);
        })
        .catch(() => {
          setloading(false);
          setHloading(false);
        });
    }, 1500);
  };

  const headerRow = {
    name: `You have ${events?.length} past ${
      events?.length > 1 ? "events" : "event"
    }`,
    date: "Event Date",
    time: "Event Time",
    guests: "Total Guests",
    attending: "Attending",
    clientName: "Client Name",
  };

  return (
    <div>
      <Row gutter={[12, 8]} className={styles.searchContainer}>
        <Col
          xs={24}
          sm={24}
          md={role === roles.client ? 24 : 12}
          xl={role === roles.client ? 24 : 10}
        >
          <SearchInput
            className={styles.inputComp}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Search"
          />
        </Col>
        {/* <Col xs={24}>
        {showCreateBtn && (
          <SubmitButton
            title={"Create"}
            onClick={null}
            btnClass={styles.submitBtn}
          />
        )}
        </Col> */}
      </Row>
      <List
        header={
          events?.length > 0 && <TableHeader item={headerRow} role={role} />
        }
        className={styles.list}
        itemLayout={width > 991 ? "horizontal" : "vertical"}
        dataSource={events}
        renderItem={(item, index) => (
          <List.Item
            className={styles.listItem}
            onClick={() => {
              if (EventDetails?.id == item.id) {
                navigate("/events/eventHistory", {
                  state: { headrTitle: "Event", eventData: item },
                });
              } else {
                dispatch(EventMiddleware.getEventDetails({ id: item?.id }))
                  .then(() =>
                    navigate("/events/eventHistory", {
                      state: { headrTitle: "Event", eventData: item },
                    })
                  )
                  .catch();
              }
            }}
          >
            <Col xs={24} lg={9}>
              <LeftGroup item={item} />
            </Col>
            <Col xs={24} lg={15}>
              <RightGroup item={item} role={role} />
            </Col>
          </List.Item>
        )}
      />
    </div>
  );
};

export default EventTableHistory;
